import { ChangeDetectionStrategy, Component } from '@angular/core';
import { CommentPanelManagerService } from '../../services';

@Component({
  selector: 'app-back-to-all-comments-action',
  templateUrl: './back-to-all-comments-action.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class BackToAllCommentsActionComponent {
  constructor(private commentPanelManagerService: CommentPanelManagerService) {}

  backToAllComments(): void {
    this.commentPanelManagerService.closeSingleThread();
  }
}
